import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormulaireColumnName, IFormulaireColumnName } from '../formulaire-column-name';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ServiceItemService } from '../../service-items/service-item.service';
import { TypeInputFormService } from '../../champs_formulaires/type-input-form/type-input-form.service';
import { FormulaireService } from '../formulaire.service';
import { BaseService } from '../../base/base.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { takeUntil } from 'rxjs/operators';
import { Formulaire } from '../../../../model/champs_formulaire/formulaire.model';
import { ChampsFormulaire, LocationType, SourceType, TypeForm } from '../../../../model/champs_formulaire/champs-formulaire.model';

@Component({
  selector: 'app-formulaire-update',
  templateUrl: './formulaire-update.component.html',
  animations: [fadeIn]
})
export class FormulaireUpdateComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  theDialogRef: MatDialogRef<FormulaireUpdateComponent>;
  column: IFormulaireColumnName;
  editForm: UntypedFormGroup;

  private countrySelected: ChampsFormulaire;

  private subs$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private serviceItemService: ServiceItemService,
    private typeInputFormService: TypeInputFormService,
    private formulaireService: FormulaireService,
    public baseService: BaseService,
    private accountService: AccountService,
    private fb: UntypedFormBuilder,
    private formService: FormService,
    private dialogRef: MatDialogRef<FormulaireUpdateComponent>,
    private columnName: FormulaireColumnName,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct formulaire update');
    const column = this.columnName.getColumnName();
    this.theDialogRef = this.dialogRef;
    this.column = column;
    this.initForm(fb, column);
  }

  ngOnInit(): void {
    console.log('## init formulaire update');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(res => {
      this.formulaireService.getObjetSelectObs()
        .pipe(takeUntil(this.subs$)).subscribe((res: Formulaire) => {
        console.log('## get formulaire selected to liste');
        try {
          console.log('## data: ', res);
          this.countrySelected = res;
          this.editForm.patchValue({
            [this.column.id]: res.id,
            [this.column.titre]: res.titre,
            [this.column.description]: res.description
          })
        }catch (e) {
          console.log('## error get country selected: ' + e.message);
        }
      });
    })
    super.setLoaded();
  }

  ngOnDestroy() {
    console.log('## destroy formulaire update');
    this.formService.free(this.subs$);
  }

  /*  private _filter(value: string): IServiceItem[] {
      let filteredList;
      try {
        const filterValue = value.toLowerCase();
        filteredList = this.serviceItemsList.filter(option => option.name.toLowerCase()
          .includes(filterValue));
      } catch (e) {
        console.log('## error filter service item: ' + e.message);
      }
      return filteredList;
    }*/

  initForm(fb: UntypedFormBuilder, column: IFormulaireColumnName) {
    if (fb && column) {
      this.editForm = fb.group({
        [column.id]: [''],
        [column.titre]: ['', [Validators.required]],
        [column.description]: ['', []]
      });
    }
  }

  /**
   * Enregistre un type de account ressource.
   */
  save() {
    console.log('## update form');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c = this.createFromForm();
    console.log('## c: ', c);
    this.formulaireService.update(c, this.formulaireService.resourceUrl)
      .subscribe(res => {
          console.log('## success update form');
          this.serverHasError = false;
          this.responseFromServer();
          this.editForm.reset();
          this.successSave = true;
          this.formulaireService.getAllObjet();
        },
        err => {
          console.log('## error update form: ', err);
          this.responseFromServer();
          this.serverHasError = true;
          this.successSave = false;
        });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

  private createFromForm(): Formulaire {
    return {
      ...new Formulaire(),
      id: this.editForm.get([this.column.id]).value,
      titre: this.editForm.get([this.column.titre]).value,
      description: this.editForm.get([this.column.description]).value
    };
  }

  closeModal() {
    console.log('## close formulaire update');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }

  reset() {
    this.editForm.reset();
  }

}